/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1TutoraiDocumentsDocumentidImport202,
  PostApiV1TutoraiDocumentsDocumentidImport400,
  PostApiV1TutoraiDocumentsDocumentidImport401,
  PostApiV1TutoraiDocumentsDocumentidImport404,
  PostApiV1TutoraiDocumentsDocumentidImport500,
  PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
  PostApiV1TutoraiDocumentsDocumentidImportPathParams,
} from "../../types/tutorAIDocumentosController/PostApiV1TutoraiDocumentsDocumentidImport.ts";
import { tutorAIImportDocumentResultViewModelSchema } from "../tutorAIImportDocumentResultViewModelSchema.ts";

export const postApiV1TutoraiDocumentsDocumentidImportPathParamsSchema =
  z.object({
    documentId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1TutoraiDocumentsDocumentidImportPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1TutoraiDocumentsDocumentidImport202Schema = z.lazy(
  () => tutorAIImportDocumentResultViewModelSchema,
) as unknown as ToZod<PostApiV1TutoraiDocumentsDocumentidImport202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1TutoraiDocumentsDocumentidImport400Schema =
  z.any() as unknown as ToZod<PostApiV1TutoraiDocumentsDocumentidImport400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1TutoraiDocumentsDocumentidImport401Schema =
  z.any() as unknown as ToZod<PostApiV1TutoraiDocumentsDocumentidImport401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1TutoraiDocumentsDocumentidImport404Schema =
  z.any() as unknown as ToZod<PostApiV1TutoraiDocumentsDocumentidImport404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1TutoraiDocumentsDocumentidImport500Schema =
  z.any() as unknown as ToZod<PostApiV1TutoraiDocumentsDocumentidImport500>;

export const postApiV1TutoraiDocumentsDocumentidImportMutationResponseSchema =
  z.lazy(
    () => postApiV1TutoraiDocumentsDocumentidImport202Schema,
  ) as unknown as ToZod<PostApiV1TutoraiDocumentsDocumentidImportMutationResponse>;
